import React from 'react';

export const IceBlueBackdrop = () => {
  return (
    <div className="absolute inset-0 z-0">
      <img
        src="/ice_blue_fluid_waves.png"
        alt="Ice Blue Fluid Waves Backdrop"
        className="w-full h-full object-cover object-center scale-100"
      />
      <div className="absolute inset-0 bg-slate-950/[0.04]" />
    </div>
  );
};
